import { useEffect, useState } from "react"
import { useLocation, useNavigate } from "react-router-dom"
import { getDocument, setAdminHint } from "../lib/adminApi.js"

// Loads a protected document (quote, proposal or business details) from the
// admin API. A 401 sends the user to the login page and back again.
// Returns { status: "loading" | "ready" | "not-found" | "error", data, error }.
export default function useAdminDocument(type, slug = "") {
  const navigate = useNavigate()
  const location = useLocation()
  const [state, setState] = useState({ status: "loading", data: null, error: "" })

  useEffect(() => {
    let active = true
    setState({ status: "loading", data: null, error: "" })
    getDocument(type, slug)
      .then((data) => active && setState({ status: "ready", data, error: "" }))
      .catch((err) => {
        if (!active) return
        if (err.status === 401) {
          setAdminHint(false)
          navigate(`/private/login?next=${encodeURIComponent(location.pathname + location.search)}`, { replace: true })
          return
        }
        setState({ status: err.status === 404 ? "not-found" : "error", data: null, error: err.message })
      })
    return () => {
      active = false
    }
  }, [type, slug, navigate, location.pathname, location.search])

  return state
}
